import React, { useEffect, useRef, useState } from 'react';
import '../../Estilo/PhotoSphere.css';

interface CustomNavbarButtonProps {
  viewer: any; 
}

export function CustomNavbarButton({ viewer }: CustomNavbarButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [value, setValue] = useState<number>(0);

  useEffect(() => {
    if (!viewer) return;

    const update = () => {
      const zoom = viewer.getZoomLevel();
      setValue(zoom);

      if (inputRef.current) {
        inputRef.current.value = String(zoom);
      }
    };

    update();

    viewer.addEventListener('zoom-updated', update);

    return () => {
      viewer.removeEventListener('zoom-updated', update);
    };
  }, [viewer]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const zoom = Number(e.target.value);
    setValue(zoom);
    viewer?.zoom(zoom);
  };

  return (
    <div className="custom-navbar-button">
      <span className="title">Zoom</span>

      <input
        ref={inputRef}
        type="range"
        onChange={handleChange}
      />

      <span className="value">{value.toFixed(0)}</span>
    </div>
  );
}
